import { collectionEngineV1 } from '../apis';
const reqPayments = collectionEngineV1('/payments', true);
export const getPaymentPortal = (caseId, amount, redirectUrl) => reqPayments('GET', `/payment-portal/${caseId}?redirectUrl=${redirectUrl}${amount ? `&amount=${amount}` : ''}`);
//# sourceMappingURL=payments.js.map